module.exports = __webpack_public_path__ + "img/activity-lottery-start.5272e391.jpg";